import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-application',
  template: `
  <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
    <mat-icon>description</mat-icon>
  </div>
  <div class="description">
      <strong>Application
          <span *ngIf="activity.meta['applicationStatus'] === 'started'">in Progress</span>
          <span *ngIf="activity.meta['applicationStatus'] === 'completed'">Completed</span>
          <span *ngIf="activity.meta['applicationStatus'] === 'signed'">Signed</span>
      </strong>
      <span>{{ activity.meta['contactName'] }} just
              <span *ngIf="activity.meta['applicationStatus'] === 'started'">accessed</span>
              <span *ngIf="activity.meta['applicationStatus'] === 'completed'">completed</span>
              <span *ngIf="activity.meta['applicationStatus'] === 'signed'">signed</span>
       the Application form at Lendio.com</span>

  </div>
  `,
  styles: []
})
export class ActivityRowApplicationComponent {

  @Input() activity;

}
